export class PartialPlant {
  address1: string;
  colorId: number;
  color: string;
  divisionId: number;
  id: number;
  inactiveFlag: boolean;
  latitude: string;
  longitude: string;
  name: string;
  systemType: number;
  useBatchPanelFlag: boolean;
  selected?: boolean;
}
